import { render, staticRenderFns } from "./YellowButton.vue?vue&type=template&id=66a936dc&scoped=true"
import script from "./YellowButton.vue?vue&type=script&lang=js"
export * from "./YellowButton.vue?vue&type=script&lang=js"
import style0 from "./YellowButton.vue?vue&type=style&index=0&id=66a936dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a936dc",
  null
  
)

export default component.exports